'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import useRequestCountryCode from '@alltrails/context/hooks/useRequestCountryCode';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useExposureEvent from '@alltrails/experiments/hooks/useExposureEvent';
import Page from '@alltrails/layout/components/Page';
import AppDownloadAndReview from '@/components/welcome/AppDownloadAndReview/AppDownloadAndReview';
import GivingBack from '@/components/welcome/GivingBack/GivingBack';
import Header from '@/components/welcome/Header/Header';
import PlusFeatureList from '@/components/welcome/PlusFeatureList/PlusFeatureList';
import ProComparison from '@/components/welcome/ProComparison/ProComparison';
import styles from './WelcomePage.module.scss';

// Figma: https://www.figma.com/design/vEOyjIPghH0mvy5cP3CMeQ/Paid-Landing-Page-Refresh--Web-?node-id=283-9175&p=f&t=tKZAhZZUlUQj0mzT-0

export default function WelcomePage() {
  const router = useRouter();
  const experiments = useExperiments();
  const searchParams = useSearchParams();
  const requestCountryCode = useRequestCountryCode();

  const isXpRedirect = searchParams.get('xpRedirect') === 'true';
  const isUSVariant = requestCountryCode === 'US';
  const isPlansWelcomePlusInfoTreatmentEnabled = isXpRedirect && experiments['web-growth-rm-plans-welcome-plus-info']?.value === 'welcome';

  const sendPlansWelcomePlusInfoExposure = useExposureEvent('web-growth-rm-plans-welcome-plus-info');

  useEffect(() => {
    if (isPlansWelcomePlusInfoTreatmentEnabled && isXpRedirect) {
      sendPlansWelcomePlusInfoExposure();

      // Remove xpRedirect param after redirecting to the welcome page
      const params = new URLSearchParams(searchParams.toString());
      params.delete('xpRedirect');
      const newUrl = params.toString() ? `?${params.toString()}` : window.location.pathname;
      router.replace(newUrl, { scroll: false });
    }
  }, [isPlansWelcomePlusInfoTreatmentEnabled, sendPlansWelcomePlusInfoExposure, isXpRedirect, searchParams, router]);

  return (
    <Page>
      <div className={styles.container}>
        <Header />
        <ProComparison />
        <PlusFeatureList isUSVariant={isUSVariant} />
        <AppDownloadAndReview />
      </div>
      <GivingBack />
    </Page>
  );
}
